import styled, { css } from 'styled-components';

import { token, Text, spaceMixin } from '@zillow/constellation';

export const StyledInactiveWrapper = styled.div`
    position: relative;
`;

export const StyledInactiveOverlay = styled.div`
    ${({ isNotActive }) => {
        if (isNotActive) {
            return css`
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                right: 0;
                background: rgba(255, 255, 255, 0.4);
                display: flex;
                justify-content: center;
                align-items: center;
            `;
        }
    }}
`;

export const StyledInactiveText = styled(Text)`
    padding: ${spaceMixin('sm')};
    background: ${token('colors.gray300')};
    color: ${token('colors.white')}
`;
